// extracted by mini-css-extract-plugin
export default {"sizer":"Sizer_sizer__o314u","input":"Sizer_input__rjkel","button":"Sizer_button__vjRVX"};